/** https://ui.shadcn.com/docs/primitives/button */

import { type VariantProps } from "class-variance-authority";
import { buttonVariants } from "./button";
import LoaderIcon from "../icons/loader";
import { cn } from "../";

export interface IconButtonProps
  extends React.ButtonHTMLAttributes<HTMLButtonElement>,
    VariantProps<typeof buttonVariants> {
  loading?: boolean;
  isActive?: boolean;
  Icon: React.FC<React.SVGProps<SVGSVGElement>>;
  iconClassName?: string;
}

const IconButton: React.FC<IconButtonProps> = ({
  className,
  iconClassName,
  variant,
  size,
  children,
  isActive,
  loading,
  Icon,
  ...props
}) => {
  return (
    <button
      className={cn(
        buttonVariants({ variant, size, className }),
        "flex items-center gap-2",
        size === "sm" && "gap-1.5",
        !!loading && "pointer-events-none",
        isActive && "bg-gray-900/10",
      )}
      {...props}
    >
      {loading ? (
        <LoaderIcon className="h-4 w-4 animate-spin" />
      ) : (
        <Icon className={cn("h-4 w-4", !!iconClassName && iconClassName)} />
      )}
      {children}
    </button>
  );
};

IconButton.displayName = "Button";

export { IconButton, buttonVariants };
